import { memo } from 'react';
import { useTheme } from '@mui/material';
import GoodJobIllustrationLight from './goodJob.svg?react';
import GoodJobIllustrationDark from './goodJob_dark.svg?react';

export const GoodJobIllustration = memo(
  (props: React.SVGProps<SVGSVGElement>) => {
    const theme = useTheme();

    if (theme.palette.type === 'dark')
      return <GoodJobIllustrationDark aria-hidden="true" {...props} />;
    return <GoodJobIllustrationLight aria-hidden="true" {...props} />;
  },
);
